import { UserRole } from '~/graphql/graphql';
import { useIsTraderEnabled } from '~/hooks/useIsTraderEnabled';
import { useUserRoleLabels } from '~/hooks/useUserRoleLabels';

export function useTradeRoleOptions(currentRole?: UserRole) {
  const isTraderEnabled = useIsTraderEnabled();
  const roleLabels = useUserRoleLabels();
  const tradeRoles: UserRole[] =
    isTraderEnabled || currentRole === UserRole.Trader
      ? [UserRole.Buyer, UserRole.Seller, UserRole.Trader]
      : [UserRole.Buyer, UserRole.Seller];
  return tradeRoles.map((role) => ({ label: roleLabels[role], value: role }));
}
